<template>
  <span class="city-selector">
    <df-nav-item v-if="dropDown">{{ cityName }}</df-nav-item>
    <df-nav-item v-else @click.stop="onToggleCity">
      <span>{{ cityName }}</span>
      <i class="df-arrow" :class="flag ? 'df-arrow_active' : ''"></i>
    </df-nav-item>
    <def-city
        v-show="flag"
        :allCities="allCities"
        :hotCities="hotCities"
        :top="position.top"
        :right="position.right"
        @onHideCity="onHideCity"
    />
  </span>
</template>

<script>
import Cookies from "js-cookie";
import { getQueryString } from '../../../utils';
export default {
  name: "CitySelector",
  components: {
    DefCity: () => import("../DefCity"),
  },
  data() {
    return {
      cityName:
          getQueryString('city') && this.getCityName(getQueryString('city')) ||
          (sessionStorage.getItem("showStore") && JSON.parse(sessionStorage.getItem("showStore")).unionInfo.city &&
              this.getCityName(JSON.parse(sessionStorage.getItem("showStore")).unionInfo.city, this.allCities)) ||
          (Cookies.get("address") &&
              JSON.parse(Cookies.get("address") || "{}").cityName),
      flag: false,
      dropDown: false,
      allCities: [],
      hotCities: [],
      df_lang: Cookies.get("df_lang"),
      position: {
        top: '28px',
        right: '0px',
      },
    };
  },
  watch: {
    $route(newVal, oldVal) {
      const arr = ["packageDetails", "OrganDetails"];
      if (oldVal.query.city && oldVal.query.city !== newVal.query.city) {
        this.getCityData();
      }

      this.dropDown = arr.includes(newVal.name);
    },
    cityName: {
      handler: function(newVal) {
        console.log('cityName', newVal)
        this.cityName = newVal;
      },
      deep: true,
      immediate: true
    },
  },
  created() {
    // 获取城市数据
    this.getCityData();
  },
  mounted() {
    document.addEventListener("click", this.onHideCity);
    this.$bus.$on("changeCity", this.onToggleCity);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onHideCity);
    this.$bus.$off("changeCity", this.onToggleCity);
  },
  methods: {
    getCityName(cityId, list) {
      let str = this.TLang("上海", "home");
      if (list && list.length > 0) {
        const arr = list.filter((item) => item.cityId == cityId);
        str = arr[0] ? this.df_lang && this.df_lang == "en-US" ? arr[0].pinyin : arr[0].name : str;
        return str;
      } else {
        return str;
      }
    },
    getCityData() {
      try {
        this.apis.newBfdHeaderApi.getCityData().then((res) => {
          this.allCities = res.cityList;
          // 获取当前城市名
          if (getQueryString("city")) {
            this.cityName = this.getCityName(getQueryString("city"), res.cityList);
          } else if (sessionStorage.getItem("showStore")) {
            this.cityName = this.getCityName(JSON.parse(sessionStorage.getItem("showStore")).unionInfo.city, res.cityList)
          } else {
            this.cityName = (Cookies.get("address") &&
                JSON.parse(Cookies.get("address") || "{}").cityName) || this.TLang("上海", "home")
          };
          this.hotCities = res.hotCities;
          if (
            (this.df_lang && this.df_lang == "en-US") ||
              window.union_isBilingual
          ) {
            this.getCityPinyin();
          }
        });
      } catch (error) {
        this.cityName = this.TLang("上海", "home");
      }
    },
    getCityPinyin() {
      if (this.allCities && this.allCities.length > 0) {
        this.allCities.forEach((i) => {
          if (i.name == this.cityName) {
            this.cityName = i.pinyin;
          }
        });
      }
    },
    onToggleCity() {
      this.flag = !this.flag;
      if(this.flag) {
        const {bottom, right} = this.$el.getBoundingClientRect();
        this.position.top = bottom + 'px';
        this.position.right = 0;
      }
    },
    onHideCity() {
      this.flag = false;
    },
  },
};
</script>

<style lang="less" scoped>
.city-selector {
  cursor: pointer;
}
</style>
